import { CatalogFormFieldEntity, CatalogFormFieldEntityApi } from './entity';

export const normalizeCatalogFormFieldEntity = (
  raw: CatalogFormFieldEntityApi
): CatalogFormFieldEntity => {
  return {
    required: raw.required,
    id: raw.id,
    label: raw.label,
    dataType: raw.data_type,
    setupRequired: raw.setup_required,
  };
};
